import { Button, styled, Typography } from "@mui/material";
import React from "react";

const StyledPaper = styled("div")({
    display: "flex",
    flexDirection: "column",
    background: "white",
    top: "50%",
    left: "50%",
    width: "300px",
    height: "125px",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    borderRadius: "3px",
    boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
    padding: "20px",
    alignItems: "center",
});

const StyledModalHeader = styled(Typography)({
    fontWeight: "600",
    marginBottom: "20px",
});

const StyledDeleteButton = styled(Button)({
    color: "#fff",
    backgroundColor: "#d32f2f",
    "&:hover": {
        backgroundColor: "#c62828",
    },
});

const DeleteConfirmationModal = (props) => {
    const { deleteRule, toggleModal, parentEntityTypeKey, modal } = props;

    const { ruleKey } = modal.data;

    return (
        <React.Fragment>
            <StyledPaper>
                <StyledModalHeader variant="h6">Delete Rule?</StyledModalHeader>
                <span style={{ marginBottom: "20px" }}>Are you sure you want to delete this rule?</span>
                <span>
                    <Button variant="outlined" onClick={() => toggleModal(false)} color="primary">
                        Cancel
                    </Button>
                    <StyledDeleteButton variant="contained" onClick={() => deleteRule(ruleKey, parentEntityTypeKey)}>
                        Delete
                    </StyledDeleteButton>
                </span>
            </StyledPaper>
        </React.Fragment>
    );
};

export default DeleteConfirmationModal;
